import {
  formatAmountToISKCurrencyString,
  formatAmountToOtherCurrencyString,
} from 'src/helpers/formatAmountToString';

export function isCurrencyClaim(product) {
  return product === 'CurrencyTurnover';
}

export function formatToISKIfNotCurrencyClaim(product, amount) {
  return isCurrencyClaim(product)
    ? '-'
    : formatAmountToISKCurrencyString(amount);
}

export function formatCurrencyClaimsToSpecialCurrencyElseToISK(
  product,
  amount,
  currency
) {
  return isCurrencyClaim(product)
    ? formatAmountToOtherCurrencyString(amount, currency)
    : formatAmountToISKCurrencyString(amount);
}
